import { _IMAPI } from "../assets/js/imapi"
const authLoginGenotp = (params) => {

    return new Promise((resolve, reject) => {

        _IMAPI._POST(_IMAPI.getService("auth-login-genotp"), null, params, function (res) {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}


const authVerifyTotp = (params) => {

    return new Promise((resolve, reject) => {

        _IMAPI._POST(_IMAPI.getService("auth-verifyOTP"), null, params, function (res) {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}

const getPorfileData = () => {
    return new Promise((resolve, reject) => {

        _IMAPI._GET(_IMAPI.getService("profile"), null, {}, (res) => {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}

const getHomePageLinks = () => {
    return new Promise((resolve, reject) => {

        _IMAPI._GET(_IMAPI.getService("get-homepage-links"), null, {}, (res) => {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}



const authLoginValidateOTP = (params) => {
    return new Promise((resolve, reject) => {

        _IMAPI._POST(_IMAPI.getService("auth-login"), null, params, function (res) {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}


const authLogout = () => {
    return new Promise((resolve, reject) => {

        _IMAPI._GET(_IMAPI.getService("auth-logout"), null, {}, (res) => {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })
}



export {
    authLoginGenotp,
    getPorfileData,
    authLoginValidateOTP,
    authLogout,
    authVerifyTotp,
    getHomePageLinks
}